import * as Sentry from '@sentry/react';

import { IAM_COMPONENT_IN_STORE, IAM_COMPONENT_SIGN_IN_SIGN_UP } from '~constants/Constants';
import { VulcanSignInSignUp } from '~exported/ramp-sign-in-sign-up/VulcanSignInSignUp';
import { VulcanInStore } from '~exported/ramp/VulcanInStore';

import { ExportExternal } from './vulcan/ExportExternal';

if (window.location.pathname.includes('in-store-sign-up')) {
    ExportExternal({
        componentName: IAM_COMPONENT_IN_STORE,
        Component: VulcanInStore
    });
} else {
    ExportExternal({
        componentName: IAM_COMPONENT_SIGN_IN_SIGN_UP,
        Component: VulcanSignInSignUp
    });
}
//@ts-ignore
const env = window?.site?.config?.env || 'prod';
if (env !== 'dev') {
    Sentry.init({
        dsn: 'https://89ead99fd1ee4679a181c434aa85aafd@o1412351.ingest.sentry.io/6777999',
        integrations: [new Sentry.BrowserTracing()],
        denyUrls: [
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i,
            /^chrome-extension:\/\//i,
            // Safari extensions
            /webkit-masked-url:\/\/hidden\//i,
            // autofill in facebook/Instagram
            /connect\.facebook\.net\/en_US\/iab\.autofill\.enhanced\.js/i
        ],
        environment: env,
        beforeSend: (event, hint) => {
            // filter web crawler log from 'Bytespider'
            return event.request?.headers?.['User-Agent']?.includes('Bytespider') ? null : event;
        },
        ignoreErrors: [
            // Error generated by a bug in auto-fill library from browser
            // https://github.com/getsentry/sentry/issues/5267
            /Blocked a frame with origin/,
            /Can't find variable: _AutofillCallbackHandler/,
            // __gcrweb is a reference by gcrweb.js, injected by the Chrome in iOS.
            /__gCrWeb./,
            /__naverapp__./,
            /window.cobrowseIOgetRedactedElementsBounds is not a function/,
            // ignore the api request failure (from user cancelling)
            /TypeError: Failed to fetch/, // android / chrome
            /TypeError: Load failed/, //ios / mac + safari
            /TypeError: NetworkError when attempting to fetch resource/, //firefox
            /register a query providerm but there is already a provider for query/
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: env === 'prod' ? 1 : 0.1
    });
}
